// extracted by css-extract-rspack-plugin
export default {"networkDescription":"src-components-network-NetworkDescription-module__networkDescription-SRT8V3","viewNetworkLink":"src-components-network-NetworkDescription-module__viewNetworkLink-u5FTow"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"networkDescription\":\"src-components-network-NetworkDescription-module__networkDescription-SRT8V3\",\"viewNetworkLink\":\"src-components-network-NetworkDescription-module__viewNetworkLink-u5FTow\"}";
        // 1793732399078
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  